import React, { useEffect } from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  List,
  ListItemText,
  ListItemButton,
  Button,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { SubmitButton } from "../components/buttons";

const DepartmentRow = (props) => {
  const {
    structure,
    GetAllChildren,
    parent,
    GetUsersByStructure,
    expandable,
    checkAll,
    onCheck,
    itemClick,
    currentStructure,
  } = props;

  const [children, setChildren] = React.useState(
    structure.list ?? []
  );
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(true);
  const [checked, setChecked] = React.useState(
    structure.selected ?? false
  );

  return (
    <div>
      <div className={"d-flex justify-content-center align-items-center"}>
        {parent(structure) ? (
          <div style={{ width: 15, borderBottom: "1px dotted black" }}></div>
        ) : null}
        <div className={"flex-grow-1"}>
          <ListItemButton
            selected={structure.id === currentStructure}
            onClick={async () => {
              itemClick(structure.id, structure);
              if (!children.length && expandable) {
                setLoading(true);
                let response = await GetAllChildren(structure.id);
                if (response) {
                  structure.list = response;
                  setChildren(response);
                }
                setLoading(false);
              } else {
                if (children.length) {
                  setShow(!show);
                }
                await GetUsersByStructure(structure.id);
              }
            }}
            className={"d-flex"}
          >
            {expandable ? <AddIcon /> : null}{" "}
            <div className={"ms-1 flex-grow-1"}>
              <ListItemText primary={structure.name} />
            </div>
            {checkAll && (
              <Checkbox
                checked={checked}
                onClick={(e) => {
                  if (children.length) {
                    e.stopPropagation();
                  }
                }}
                onChange={() => {
                  structure.selected = !checked;
                  setChecked(!checked);

                  if (onCheck) {
                    onCheck(!checked, structure);
                  }
                }}
              />
            )}
          </ListItemButton>
        </div>
      </div>
      {children.length && show && expandable ? (
        <div className={"d-flex"}>
          <div style={{ borderLeft: "1px dotted black", marginLeft: 15 }}></div>
          <div className={"flex-grow-1"}>
            <DepartmentList
              expandable={expandable}
              list={children}
              parent={() => structure}
              checkAll={checkAll}
              onCheck={onCheck}
              currentStructure={currentStructure}
              GetAllChildren={GetAllChildren}
              itemClick={itemClick}
              GetUsersByStructure={GetUsersByStructure}
            />
          </div>
        </div>
      ) : loading ? (
        <div className={"text-center"}>
          <CircularProgress size={12} />
        </div>
      ) : null}
    </div>
  );
};

export const DepartmentList = (props) => {
  const {
    list,
    GetAllChildren,
    parent,
    GetUsersByStructure,
    expandable,
    checkAll,
    onCheck,
    itemClick,
    currentStructure
  } = props;
  return (
    <List>
      {list?.map((struct) => (
        <DepartmentRow
          expandable={expandable}
          parent={parent}
          structure={struct}
          currentStructure={currentStructure}
          onCheck={onCheck}
          checkAll={checkAll}
          itemClick={itemClick}
          GetAllChildren={GetAllChildren}
          GetUsersByStructure={GetUsersByStructure}
        />
      ))}
    </List>
  );
};

export const DepartmentCard = (props) => {
  const {
    list,
    GetAllChildren,
    GetUsersByStructure,
    expandable,
    onSearch,
    checkAll,
    onCheck,
    itemClick,
    maxHeight,
    currentStructure
  } = props;

  return (
    <Card variant={"outlined"}>
      <CardHeader
        title={
          <div className="row ">
            <span className="text-uppercase fw-bolder col-4 ">
              MASTER
            </span>
            <Button
              className="text-uppercase fw-bold text-muted col-7 text-start"
              onClick={() => { }}
            >
            </Button>
          </div>
        }
        titleTypographyProps={{ variant: "subtitle1" }}
        action={
          <input
            placeholder="Search here.."
            className="form-control form-control-sm"
            type="text"
            onKeyUp={onSearch}
          />
        }
      />
      <CardContent style={{ maxHeight, overflowY: "auto" }}>
        <DepartmentList
          expandable={expandable}
          list={list}
          parent={() => null}
          checkAll={checkAll}
          itemClick={itemClick}
          currentStructure={currentStructure}
          onCheck={onCheck}
          GetAllChildren={GetAllChildren}
          GetUsersByStructure={GetUsersByStructure}
        />
      </CardContent>
    </Card>
  );
};

const SelectApprover = (props) => {
  const [checked, setChecked] = React.useState([]);
  const [searchResults, setSearchResults] = React.useState([]);
  const [query, setQuery] = React.useState(null);
  const [currentStructure, setCurrentStructure] = React.useState(null);
  const [checkedDepartments, setCheckedDepartments] = React.useState([]);
  const [allUsers, setAllUsers] = React.useState([]);
  const [searchUsers, setSearchUsers] = React.useState(null);

  const {
    users,
    setSelect,
    structure,
    loggedUser,
    onSelectUser,
    GetAllChildren,
    GetUsersByStructure,
    checkAll,
    searchStructure,
    checkDeputy,
    SearchStructure,
  } = props;



  useEffect(() => {
    if (users) {
      const arr = users.filter(
        (v) => allUsers.filter((vi) => vi.id === v.id).length <= 0
      );
      const otherChecked = arr.filter(
        (v) =>
          checked.filter((vi) => vi.id === v.id).length <= 0 &&
          checkedDepartments.filter((vi) => vi.id === v.structureId).length > 0
      );
      setChecked(checked.concat(otherChecked));
      setAllUsers(allUsers.concat(arr));
    }
  }, [users]);

  let filterUsers = searchUsers ?? allUsers;
  let filterStructure = searchStructure.length ? searchStructure : structure;

  const containDeputy = checkDeputy === true && filterUsers?.filter((v) => v.role?.name === 'role0' && v.structureId === currentStructure && v.id !== loggedUser?.userId)?.length > 0;

  const checkedUser = (user) => {
    let temp = [...checked];
    if (!temp.includes(user)) {
      temp.push(user);
      setChecked(temp);
    }
  };
  const unCheckUser = (user) => {
    let array = [...checked];
    let index = array.indexOf(user);
    if (index !== -1) {
      array.splice(index, 1);
      setChecked(array);
    }
  };
  const onCheck = (user) => {
    if (!checked.includes(user)) {
      checkedUser(user);
    } else {
      unCheckUser(user);
    }
  };
  const onCheckAll = (user) => {
    if (checked.length !== allUsers.length) {
      setChecked(user);
    } else {
      setChecked([]);
    }
  };
  const handleOnkeyUp = (e) => {
    let value = e.currentTarget.value.toLowerCase();
    let newArray = users?.filter(
      (item) => item?.UserInfo?.names.toLowerCase().indexOf(value) !== -1
    );
    setSearchUsers(newArray);
  };
  const handleOnkeyUpStrucrure = async (e) => {
    const value = e.currentTarget.value.trim().toLowerCase();
    if (value.length < 2) {
      setQuery(null);
    } else {
      setQuery(value);
    }
    if (SearchStructure && value.length > 1) {
      const array = await SearchStructure(value);
      if (array) {
        setSearchResults(array);
      }
    }
  };

  const [active, setActive] = React.useState(Number);

  return (
    <Card>
      <CardHeader
        title={"Select In User"}
        titleTypographyProps={{ variant: "h6" }}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSelectUser(checked);
          setSelect(false);
        }}
      >
        <CardContent>
          <div className="row ">
            <div className="col ">
              <DepartmentCard
                onSearch={handleOnkeyUpStrucrure}
                expandable={query === null}
                maxHeight={"750px"}
                currentStructure={currentStructure}
                GetUsersByStructure={GetUsersByStructure}
                parent={() => null}
                list={query === null ? filterStructure : searchResults}
                checkAll={checkAll}
                onCheck={(checkedUser, structure) => {
                  if (
                    checkedDepartments.filter((v) => v.id === structure.id)
                      .length > 0
                  ) {
                    setCheckedDepartments(
                      checkedDepartments.filter(
                        (value) => value.id !== structure.id
                      )
                    );
                    setChecked(
                      checked.filter((v) => v.structureId !== structure.id)
                    );
                  } else {
                    setCheckedDepartments([structure, ...checkedDepartments]);
                    const newChecked = checked
                      .filter((v) => v.structureId !== structure.id)
                      .concat(
                        allUsers.filter((v) => v.structureId === structure.id)
                      );

                    setChecked(newChecked);
                  }
                }}
                itemClick={(id) => {
                  if (!checkAll && id !== currentStructure) {
                    setChecked([]);
                  }
                  setCurrentStructure(id);
                }}
                GetAllChildren={(id) => {
                  GetUsersByStructure(id);

                  return GetAllChildren(id);
                }}
              />
            </div>
            <div className="col">
              <Card variant={"outlined"}>
                <CardHeader
                  title={"USER"}
                  titleTypographyProps={{ variant: "subtitle1" }}
                  action={
                    <input
                      placeholder="Search here.."
                      className="form-control form-control-sm"
                      type="text"
                      onKeyUp={(e) => handleOnkeyUp(e)}
                    />
                  }
                />

                <CardContent>
                  <ul className="list-group p-3">
                    <li className="list-group-item">
                      <input
                        className="form-check-input me-1"
                        type="checkbox"
                        checked={checked.length === allUsers.filter((v) => v.structureId === currentStructure).length}
                        onChange={() => {
                          onCheckAll(allUsers.filter((v) => v.structureId === currentStructure && (containDeputy &&( v.role?.name === 'role0' || !containDeputy))));
                        }}
                      />
                    </li>
                    {filterUsers
                      ?.filter(
                        (user) =>
                        (user.structureId === currentStructure ||
                          checkedDepartments.filter(
                            (v) => v.id === user.structureId
                          ).length > 0)
                      )
                      ?.map((user) => {

                        const disabled = containDeputy && user.role?.name !== 'role0';

                        return (
                          <li className="list-group-item">
                            <input
                              className="form-check-input me-1"
                              type="checkbox"
                              checked={
                                checked.filter((v) => v.id === user.id)
                                  .length > 0
                              }
                              disabled={disabled}
                              onChange={(e) => {
                                onCheck(user);
                              }}
                            />
                            <span className={disabled ? 'text-muted' : undefined}>{user?.UserInfo?.names} {user?.Position ? <b>({user?.Position?.name})</b> : null}</span>
                          </li>
                        );
                      })}
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>
        </CardContent>
        <CardActions className={"float-end"}>
          <SubmitButton name="ADD" />
        </CardActions>
      </form>
    </Card>
  );
};
export default SelectApprover;
